<script>
  export let graph;
  export let width;
  export let height;
  export let style;

  const nodeRadius = 8;
  $: links = graph.links;
  $: nodes = graph.nodes;
</script>

<svg {width} {height} {style}>
  <defs>
    <linearGradient id="nodeGradient" gradientTransform="rotate(45)">
      <stop offset="5%" stop-color="#80f1ef" />
      <stop offset="95%" stop-color="#2eb6e8" />
    </linearGradient>
  </defs>

  {#each links as link}
    {#if link.highlight}
      <g stroke="#f1b6e8" stroke-opacity="0.6" stroke-width="2">
        <line
          x1={link.source[0]}
          y1={link.source[1]}
          x2={link.target[0]}
          y2={link.target[1]}
        />
      </g>
    {:else}
      <g stroke="#999" stroke-opacity="0.6" stroke-width="2">
        <line
          x1={link.source[0]}
          y1={link.source[1]}
          x2={link.target[0]}
          y2={link.target[1]}
        />
      </g>
    {/if}
    
    <rect
      x={(link.source[0] + link.target[0]) / 2 - 10}
      y={(link.source[1] + link.target[1]) / 2 - 10}
      width="22"
      height="12"
      fill="white"
    />
    <text
      class="link unselectable"
      x={(link.source[0] + link.target[0]) / 2}
      y={(link.source[1] + link.target[1]) / 2}
      text-anchor="middle">{link.value}</text
    >
  {/each}

  {#each nodes as node}
    <circle
      fill="white"
      cx={node.x + nodeRadius * 1.5}
      cy={node.y - nodeRadius * 1.5 - 5}
      r="8"
    />

    <g stroke="white" stroke-width="1.5" fill="url('#nodeGradient')"
      ><circle r={nodeRadius} cx={node.x} cy={node.y}>
        <title>{node.id}</title>
      </circle></g
    >
    <text
      class="unselectable"
      x={node.x + nodeRadius * 1.5}
      y={node.y - nodeRadius * 1.5}
      text-anchor="middle">{node.id}</text
    >
  {/each}
</svg>

<style>
  .link {
    fill: #999;
    font-size: 0.725em;
    font-weight: 200;
  }
</style>
